export class ViewsErros extends Error {}

export class ViewNotFoundError extends Error {
  message = 'View not found. View was not loaded or an error occurred.';
}
